/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmAuthV1ApiKeyState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_AUTH_V1_API_KEY_STATE_ENTITY_NAME = 'ixm.auth.v1.ApiKey';
export const ixmAuthV1ApiKeyStateEntity = new schema.Entity<IxmAuthV1ApiKeyState>(IXM_AUTH_V1_API_KEY_STATE_ENTITY_NAME, {}, { idAttribute: 'clientId' });

